import { Column } from '@tanstack/react-table';

type SizedColumnMeta = { fixedWidth?: boolean } | undefined;

// Column widths live on the grid container as one template instead of per-cell flex rules.
// A column's TanStack size acts as both its base width and its grow weight — tracks expand
// proportionally to size once the container exceeds the summed sizes, which resolves to the
// same widths as the old `flex: <size> 0 auto; width: <size>px` cells. Columns flagged with
// `meta: { fixedWidth: true }` get a rigid track that never grows.
export function buildGridTemplateTracks(columns: Column<any, unknown>[]): string[] {
  return columns.map((column) => {
    const size = column.getSize();
    return (column.columnDef.meta as SizedColumnMeta)?.fixedWidth ? `${size}px` : `minmax(${size}px, ${size}fr)`;
  });
}
